import React from 'react';
import DeviceTokensSection from '../../../components/DeviceTokensSection';

const ZarizeniTab: React.FC = () => <DeviceTokensSection />;

export default ZarizeniTab;
